import React from "react";
import Section from "components/common/Section";
import PropTypes from "prop-types";
import "./PictureSectionWithCaption.scss";

const mapAdditionalImage = ({imageSrc, imageSrc2x}, index) => (
	<img key={index} className="pictureSectionImg border-radius-small" src={imageSrc} srcSet={`${imageSrc2x} 2x`} style={{marginTop: 10}} />
);

const PictureSectionWithCaption = ({ className = "", imageSrc, imageSrc2x, caption, additionalImages=[] }) => {

	const additionalImagesRendered = additionalImages.map(mapAdditionalImage);
	return (
		<Section className={`pictureSection has-mobile-gutter ${className} text-align-center`}>
			<span className="caption title font-size-med">
				{caption}
			</span>
			<div className="desktop-max-width-large text-align-center">
				<img className="pictureSectionImg border-radius-small" src={imageSrc} srcSet={`${imageSrc2x} 2x`}/>
				{additionalImagesRendered}
			</div>
		</Section>
	);
};

PictureSectionWithCaption.propTypes = {
	className: PropTypes.string,
	imageSrc: PropTypes.string.isRequired,
	imageSrc2x: PropTypes.string.isRequired,
}

export default PictureSectionWithCaption;



// WEBPACK FOOTER //
// ./src/components/common/PictureSectionWithCaption.js